import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { BookingLookupResultState } from "../../../states/BookingSearchFormState";
import './OtpFormPage.css'

interface Attrs {    
    bookingLookupResultState: BookingLookupResultState,
    messageProvider: MessageProvider;
    emailOrPhone: string|null;
    onSubmit: (otpValue: string) => void;
    onResentOtp: () => void;
}

let isDirty = false;
let otpValue = "";
function OtpFormPage(): m.Component<Attrs> {

    return {
        onupdate(vnode){
            isDirty = false;
            if(vnode.attrs.bookingLookupResultState == 'INCORRECT_OTP'){
                m.redraw();
            }
        },
        view(vnode) {    
            const { bookingLookupResultState, messageProvider, emailOrPhone, onSubmit, onResentOtp} = vnode.attrs;    
            return [
                m(ContainerRowCol,   
                    m("div.card shadow-lg text-center mt-4 rounded-16", [
                        m("div.card-header rounded-top-16", "OTP Verification"),
                        m("div.card-body p-4", [
                            m("div", "Enter the OTP you received at"),
                            m("div", m("small.font-weight-bold", emailOrPhone)),
                            m("div.mt-4", [
                                m("div.input-group input-group-default", [
                                    m("span.input-group-text", {id: "inputGroup-sizing-default"}, 
                                        m("i.bi bi-envelope text-secondary")
                                    ),
                                    m("input", {
                                            type: "text",
                                            class: "custom-form-control form-control",
                                            "aria-label": "Sizing example input",
                                            "aria-describedby": "inputGroup-sizing-sm",
                                            placeholder: "Enter OTP",
                                            onchange: (event) => {
                                                otpValue = event.target.value;
                                            }
                                    })
                                ]),
                                (bookingLookupResultState == 'INCORRECT_OTP' && otpValue === "")?
                                m("div.tooltip",
                                    m("span.tooltiptext", "Please enter your OTP first!")
                                ): null
                            ]),
                            (bookingLookupResultState == 'INCORRECT_OTP' && otpValue != "")? m("div", m("small.pt-2 text-danger text-left", "Incorrect OTP.")): null,
                            m("div.pt-2 row", 
                                m("div.col-8 text-left text-primary",
                                    m("small", {
                                        onclick: (event) => {
                                                event.preventDefault();
                                                onResentOtp();
                                            }
                                    }, "Resend OTP")
                                )
                            ),
                            m("div.mt-3",
                                (!isDirty)?
                                m("button", {
                                    class: "text-white btn btn-block btn-primary shadow-sm mmd-ripple raised pt-2 pb-2 rounded",
                                    onclick: function (event) {
                                        event.preventDefault();
                                        isDirty = true;
                                        onSubmit(otpValue);
                                    },
                                }, m("strong", "Submit")):
                                m("button", {
                                    class:"btn btn-primary btn-block d-flex shadow-sm mmd-ripple raised pt-2 pb-2 align-items-center justify-content-center rounded",
                                    disabled: true
                                }, [
                                    m("span", {
                                        "role":"status",
                                        class:"spinner-border spinner-border-sm mr-1"
                                    }),
                                    m("span", m("strong", "Submit"))
                                ])
                            )
                        ])
                    ])              
                )           
            ]
        }
    }
}

function ContainerRowCol(): m.Component<{}>  {
    return {
        view: function(vnode) {
            return m("div.container",
                m("div.row", 
                    m("div.col", vnode.children)
                )
            )
        }
    }
}


export default OtpFormPage;

